export default class Link {
  constructor(options) {
    this.url = options.url;
    this.onClick = options.onClick;
    this.target = options.target;
    this.rel = options.target === '_blank' ? 'noopener noreferrer' : null;
  }
}
